import { ArrowUpRight, ArrowDownRight } from "lucide-react";

interface Delta {
  label: string;
  direction: "up" | "down";
  tone: "pos" | "neg" | "muted";
}

interface KpiCardProps {
  label: string;
  value: string | number;
  sub?: string;
  delta?: Delta | null;
  accent?: string; // tailwind color class for a small left marker, optional
  onClick?: () => void;
  style?: React.CSSProperties;
}

const TONE: Record<string, string> = {
  pos: "text-pos bg-pos/10",
  neg: "text-neg bg-neg/10",
  muted: "text-muted bg-black/[0.05]",
};

export default function KpiCard({ label, value, sub, delta, onClick, style }: KpiCardProps) {
  return (
    <div
      onClick={onClick}
      style={style}
      className={`cx-card p-4 sm:p-5 animate-fade-up transition-all ${
        onClick ? "cursor-pointer hover:shadow-pop hover:-translate-y-0.5" : ""
      }`}
    >
      <div className="flex items-start justify-between gap-2">
        <p className="text-[12.5px] font-medium text-muted min-w-0 truncate">{label}</p>
        {delta && (
          <span className={`cx-chip ${TONE[delta.tone]} shrink-0 whitespace-nowrap`}>
            {delta.direction === "up" ? (
              <ArrowUpRight className="w-3 h-3" />
            ) : (
              <ArrowDownRight className="w-3 h-3" />
            )}
            {delta.label}
          </span>
        )}
      </div>
      <p className="text-metric text-night tabular mt-2">{value}</p>
      {sub && <p className="text-[12.5px] text-faint mt-1.5">{sub}</p>}
    </div>
  );
}
